import React, { Component } from 'react';
import pitstopRigConstructing from 'img/pitstop_rig_constructing.mp4';

class HowItWorks extends Component {
  render() {
    return (
      <div className="thunderbolt__page how-it-works">
        <div className="content-page">
          <h1>{this.props.page.content.contentFields.documentName}</h1>

          <div className="how-it-works__inner">
            <div className="how-it-works--steps">
              <div className="step step--1">
                <div className="number">1.</div>
                <div className="number-content">
                  <h4>{this.props.page.content.contentFields.step1Text}</h4>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.props.page.content.contentFields
                        .step1SubText,
                    }}
                  />
                </div>
              </div>
              <div className="step step--2">
                <div className="number">2.</div>
                <div className="number-content">
                  <h4>{this.props.page.content.contentFields.step2Text}</h4>
                  <p>{this.props.page.content.contentFields.step2SubText}</p>
                </div>
              </div>
              <div className="step step--3">
                <div className="number">3.</div>
                <div className="number-content">
                  <h4>{this.props.page.content.contentFields.step3Text}</h4>
                  <p>{this.props.page.content.contentFields.step3SubText}</p>
                </div>
              </div>
              <div className="step step--4">
                <div className="number">4.</div>
                <div className="number-content">
                  <h4>{this.props.page.content.contentFields.step4Text}</h4>
                  <p>{this.props.page.content.contentFields.step4SubText}</p>
                </div>
              </div>
            </div>

            <div className="how-it-works--image">
              <video
                src={pitstopRigConstructing}
                controls={false}
                playsInline
                loop
                muted
                autoPlay
              />
              <div
                className="intro-block"
                dangerouslySetInnerHTML={{
                  __html: this.props.page.content.contentFields.introText,
                }}
              />
              <div className="how-it-works--steps-footer">
                {this.props.page.content.contentFields.stepFooter}
              </div>
            </div>
          </div>
          <div className="how-it-works--footer">
            {this.props.page.content.contentFields.footerButtonText && (
              <a
                className="thunderbolt-button thunderbolt-button--large"
                href={this.props.page.content.contentFields.footerButtonLink}
              >
                {this.props.page.content.contentFields.footerButtonText}
              </a>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default HowItWorks;
